import axios from "axios";
import { Apis } from "constants/apis";
import { getToken } from "utils/token";


const getProductDetails = async (payload: number) => {
    let queryParams = `?itemId=${payload}`;

    
    const { data } = await axios.get(`${Apis.PRODUCT_DISCOVERY_DETAILS}${queryParams}`, { headers: { Authorization: getToken() } })
    return data
}

export default getProductDetails